import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-bg px-6 text-center">
      <SEO
        title="404 – Siden blev ikke fundet"
        description="Beklager, men siden du leder efter findes desværre ikke hos Pabst Teknik ApS."
        noindex={true}
      />
      <div className="mx-auto max-w-md flex flex-col items-center gap-6">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-rose-50 text-rose-500 border border-rose-100 shadow-sm">
          <i className="fa-regular fa-circle-question text-4xl" />
        </div>
        <h1 className="text-4xl font-extrabold text-brand-dark sm:text-5xl">404</h1>
        <h2 className="text-xl font-bold text-slate-800">Siden blev ikke fundet</h2>
        <p className="text-sm text-slate-500 leading-relaxed">
          Beklager, men den side du leder efter findes ikke, er blevet flyttet eller er midlertidigt utilgængelig.
        </p>
        <Link
          to="/"
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand-accent px-8 py-3.5 text-sm font-bold text-white shadow-md transition-all hover:bg-brand-accent-hover"
        >
          <i className="fa-regular fa-house" />
          <span>Gå til forsiden</span>
        </Link>
      </div>
    </div>
  );
}
